export default [
  // 功能说明
  {
    path: '/transfer-inform',
    component: () => import('../../views/transfer/Inform.vue'),
    name: 'transfer-inform',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  {
    path: '/transfer-notice',
    component: () => import('../../views/transfer/Notice.vue'),
    name: 'transfer-notice',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  {
    path: '/transfer-step',
    component: () => import('../../views/transfer/Step.vue'),
    name: 'transfer-step',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
];
